<div mat-dialog-title>
  <div class="modal__header">
    <div class="modal__title">
      <h1>Share Folder</h1>
    </div>
    <span class="mt-2"> Please select groups below where '{{ data.folder.name }}' folder will be shared. </span>
    <button
      class="close-button"
      mat-dialog-close>
      <mat-icon class="material-symbols-rounded">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content
  aria-label="Generic modal"
  class="modal-container md-dialog-container generic-modal share-settings">
  <div class="px-10 pb-2 w-full generic-modal__content">
    <h3 class="mt-0">Groups To Share</h3>

    <scope-ui-checkbox
      title="Select All"
      [ngModel]="isAllSelected"
      (ngModelChange)="selectAll()"></scope-ui-checkbox>

    <div *ngFor="let group of groups; trackBy: trackById">
      <scope-ui-checkbox
        [title]="group.companyGroupName"
        [(ngModel)]="group.isShared"></scope-ui-checkbox>
    </div>
  </div>

  <div class="d-flex d-flex-justify-end px-10 pt-8 pb-4">
    <div class="generic-modal__buttons">
      <button
        mat-button
        mat-dialog-close>
        Cancel
      </button>
      <button
        class="main-action-button ml-4"
        mat-button
        mat-flat-button
        (click)="submit()">
        Share Settings
      </button>
    </div>
  </div>
</mat-dialog-content>
